<template>
    <div>
        <!--<el-card>-->
            <!--<el-row :gutter="20">-->
                <!--<el-col :span="6">-->
                    <!--<div>-->
                        <!--<el-statistic-->
                            <!--:value="value1"-->
                            <!--:title="title1"-->
                        <!--&gt;</el-statistic>-->
                    <!--</div>-->
                <!--</el-col>-->
                <!--<el-col :span="6">-->
                    <!--<div>-->
                        <!--<el-statistic-->
                            <!--:value="value2"-->
                            <!--:title="title2"-->
                        <!--&gt;</el-statistic>-->
                    <!--</div>-->
                <!--</el-col>-->
                <!--<el-col :span="6">-->
                    <!--<div>-->
                        <!--<el-statistic-->
                            <!--:value="value3"-->
                            <!--:title="title3"-->
                        <!--&gt;</el-statistic>-->
                    <!--</div>-->
                <!--</el-col>-->
                <!--<el-col :span="6">-->
                    <!--<div>-->
                        <!--<el-statistic-->
                            <!--:value="value4"-->
                            <!--:title="title4"-->
                        <!--&gt;</el-statistic>-->
                    <!--</div>-->
                <!--</el-col>-->
            <!--</el-row>-->
        <!--</el-card>-->

        <el-card>
            <el-form :inline="true" label-suffix=":">
                <!--<el-form-item>-->
                    <!--<el-select v-model="loginUriForm.loginUri" filterable placeholder="请选择">-->
                        <!--<el-option-->
                            <!--v-for="item in yunweiLoginList"-->
                            <!--:key="item.id"-->
                            <!--:label="item.server_name"-->
                            <!--:value="item.server_url">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
                <el-form-item>
                    <el-date-picker
                        v-model="dateTime"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyyMMdd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="showDAUAndCharge">查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <el-card v-show="isShow">
            <div slot="header" class="clearfix">
                <span>DAU</span>
            </div>
            <component-echart :option="option1" :id="'dau'" :isRefresh="isRefresh1"></component-echart>
        </el-card>

        <el-card v-show="isShow">
            <div slot="header" class="clearfix">
                <span>Charge</span>
            </div>
            <component-echart :option="option2" :id="'charge'" :isRefresh="isRefresh2"></component-echart>
        </el-card>
    </div>
</template>

<script>
    import dauApi from '../service/dau_api'
    import commonApi from '../service/common_api'
    import {
        mapState
    } from 'vuex';
    import componentEchart from '../components/component_echart'

    export default {
        name: "home",
        data () {
            return {
                value1: 0,
                value2: 0,
                value3: 0,
                value4: 0,
                title1: '当前总在线',
                title2: '当前总DAU',
                title3: '当前总注册（账号）',
                title4: '当前总注册（角色）',

                loginUriForm: {
                    loginUri:''
                },
                option1: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    toolbox: {
                    },
                    legend: {
                        data: [],
                        top: '0px',
                        left: '200px'
                    },
                    xAxis:[
                        {
                            type: 'category',
                            data: [],
                            axisPointer: {
                                type: 'shadow'
                            },
                            axisLabel: {
                                formatter: '{value}'
                            }
                        }
                    ]
                    ,
                    yAxis:
                        {
                            type: 'value',
                            name: '人数',
                            min: 0,
                            max: 50000,
                            interval: 10000,
                            axisLabel: {
                                formatter: '{value}'
                            },
                            nameTextStyle: {
                                fontSize: 16
                            }
                        }
                    ,
                    series: [

                    ]
                },

                isRefresh1: false,
                option2: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    toolbox: {
                    },
                    legend: {
                        data: [],
                        top: '0px',
                        left: '200px'
                    },
                    xAxis:[
                        {
                            type: 'category',
                            data: [],
                            axisPointer: {
                                type: 'shadow'
                            },
                            axisLabel: {
                                formatter: '{value}'
                            }
                        }
                    ]
                    ,
                    yAxis:
                        {
                            type: 'value',
                            name: '金额',
                            min: 0,
                            max: 50000,
                            interval: 10000,
                            axisLabel: {
                                formatter: '{value}'
                            },
                            nameTextStyle: {
                                fontSize: 16
                            }
                        }
                    ,
                    series: [

                    ]
                },

                isRefresh2: false,
                isShow: false,

                dateTime: ''
            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverWorldList: state => state.server.serverWorldList,
            }),
        },
        created() {
            // this.grabYunweiLoginInfo();

        },
        methods: {
            // 获取登录服和战斗服数据
            grabYunweiLoginInfo() {
                let self = this;
                commonApi.getConfs({
                    tables: 'yunwei_server_config'
                }).then(res => {
                    self.yunweiLoginList = [];
                    let yunweiServerConfig = res.yunwei_server_config;
                    yunweiServerConfig.forEach(item => {
                        if (item.server_type == 'login') {
                            self.yunweiLoginList.push(item);
                        }
                    })
                })
            },
            // 当前各服dau
            serverDau() {
                dauApi.serverDau({
                    token: this.token,
                    loginUriForm: this.loginUriForm
                }).then(res => {

                })
            },
            showDAUAndCharge() {
                this.isShow = true;

                this.isRefresh1 = true;
                setTimeout(() => {
                    this.getAllDauRecords();
                    this.isRefresh1 = false;
                },2000)
            },

            // 分服充值  分服dau数据
            getAllDauRecords() {
                var recordDateAfter = this.dateTime[0];
                var recordDateBefore = this.dateTime[1];

                dauApi.getAllDauRecords({
                    token: this.token,
                    recordsForm: {
                        recordDateAfter: recordDateAfter,
                        recordDateBefore: recordDateBefore
                    }
                }).then(res => {
                    var data = res;

                    let tempArr = [];
                    let Data = [];
                    for (let i = 0; i < data.length; i++) {
                        if (tempArr.indexOf(data[i].gameServer) === -1) {
                            Data.push({
                                gameServer: data[i].gameServer,
                                dataInfo: [data[i]]
                            });
                            tempArr.push(data[i].gameServer);
                        } else {
                            for (let j = 0; j < Data.length; j++) {
                                if (Data[j].gameServer == data[i].gameServer) {
                                    Data[j].dataInfo.push(data[i]);
                                    break;
                                }
                            }
                        }
                    }

                    Data.forEach(item => {
                        let itemDayData = [];
                        item.dataInfo.forEach(iitem => {
                            itemDayData.push(iitem.recordDate);
                            item.itemDayData = itemDayData;
                        })
                    })

                    let dateArr = [];
                    let dateTempArr = [];
                    Data.forEach(item => {
                        for (let i = 0; i < item.itemDayData.length; i++) {
                            if (dateTempArr.indexOf(item.itemDayData[i]) === -1) {
                                dateArr.push(item.itemDayData[i]);
                                dateTempArr.push(item.itemDayData[i]);
                            }
                        }
                        dateArr = dateArr.sort();
                    })

                    this.option1.xAxis[0].data = dateArr;
                    this.option2.xAxis[0].data = dateArr;


                    Data.forEach(dataItem => {

                        // 找出 data2 中缺失的日期
                        const missingDates = dateArr.filter(value => !dataItem.itemDayData.includes(value));

                        missingDates.forEach(item => {
                            dataItem.dataInfo.push({
                                tdDau: 0,
                                tdCharge: 0,
                                recordDate: item
                            })
                        })
                        dataItem.dataInfo.sort((a,b) => a.recordDate - b.recordDate)
                    })

                    Data.forEach(item => {
                        let itemDauData = [];
                        let itemChargeData = [];
                        let itemDayData = [];
                        item.dataInfo.forEach(iitem => {
                            itemDauData.push(iitem.tdDau);
                            itemChargeData.push(iitem.tdCharge/100);
                            itemDayData.push(iitem.recordDate);
                            item.itemDauData = itemDauData;
                            item.itemChargeData = itemChargeData;
                            item.itemDayData = itemDayData;
                        })
                    })


                    let max1 = data[0].tdDau;
                    let max2 = data[0].tdCharge/100;
                    for (var i=0;i<data.length;i++) {
                        if (data[i].tdDau > max1) {
                            max1 = data[i].tdDau;
                        }

                        if (data[i].tdCharge/100 > max2) {
                            max2 = data[i].tdCharge/100;
                        }
                    }

                    max1 = Math.ceil(max1 / 10000) * 10000;
                    max2 = Math.ceil(max2 / 10000) * 10000;
                    this.option1.yAxis.max = max1;
                    this.option2.yAxis.max = max2;
                    this.option1.yAxis.interval = max1/5;
                    this.option2.yAxis.interval = max2/5;

                    Data.forEach(item => {
                        this.option1.series.push({
                            name: item.gameServer,
                            type: 'line',
                            data: item.itemDauData,
                            markLine: {
                                symbol: ['none', 'none'],
                                label: { show: false },
                            },
                        });

                        this.option1.legend.data.push({
                            name:item.gameServer,
                            icon:'roundRect',
                            textStyle:{ fontSize: 10}
                        });

                        this.option2.series.push({
                            name: item.gameServer,
                            type: 'line',
                            data: item.itemChargeData,
                            markLine: {
                                symbol: ['none', 'none'],
                                label: { show: false },
                            },
                        });

                        this.option2.legend.data.push({
                            name:item.gameServer,
                            icon:'roundRect',
                            textStyle:{ fontSize: 10}
                        });

                    });
                });
            },
        },
        components: {
            componentEchart
        }
    }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/views/home.vue